module.exports = __webpack_public_path__ + "static/TT1332_TW-MARK-M01-clean-bb7eb467ec20699f59aaa938c4027430.png";